import { Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  WizBaseCollector,
  WizCheckbox,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { PivotField } from '../../../../../manager/baselines/pivot-field.obj';
import { ALK_EVENT_TYPE, WIDGET_KIND } from '../../../../../model/enums';

/**
 * rendu des champs disponibles 
 */
@Component({
  selector: 'pivot-edit-item-renderer',
  templateUrl: './pivot-edit-item.renderer.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotEditItemRenderer implements IWizItemRenderer<null, PivotField> {
  @HostBinding('style.width') forcedWidth = '100%';
  
  @ViewChild('cbPinned', { read: WizCheckbox }) cbPinned: WizCheckbox;

  public data: PivotField;

  @Input()
  owner: WizBaseCollector;

  /** affichage de l'icone de conf du champ */
  get showSettings(): boolean {

    if(this.owner.id === 'freeList') {
      return false; // pas d'édition dans la liste de sélection
    }


    // c'est un pkd dans la liste de choix
    const pf: PivotField = this.data as PivotField;
    if (pf.popUpMode === WIDGET_KIND.GRID 
        || pf.popUpMode === WIDGET_KIND.PIVOT
        || pf.popUpMode === WIDGET_KIND.TILE 
        || pf.popUpMode === WIDGET_KIND.GLOBAL_FILTER) {
      return true;
    } else if (pf.popUpMode === WIDGET_KIND.LIST || pf.popUpMode === WIDGET_KIND.FORM) {
      if (this.owner.id === 'lstData') {
        return true;
      }
    } else if(pf.popUpMode === WIDGET_KIND.TIMELINE || pf.popUpMode === WIDGET_KIND.CALENDAR) {
      // if (this.owner.id === 'lstRow' || this.owner.id === 'lstFilter' || this.owner.id === 'lstData') {
        return true;
      // }
    }
    
    return false; // la liste de choix contient des pkd, pas des pivotFields
  }

  constructor(public elementRef: ElementRef) {}

  /** mise en évidence des formules I */
  public dataClass(): string {
    if (this.isEditable()) {
      return 'componentLabel listItemFont';
    }
    // } else 
    // if(this.data.mode && this.data.mode ===  FormulaCoreEngine.MEASURE_MODE_INTERACT) {
    //   return 'componentLabel';
    // }
    return 'listItemFont';
  }

  /** l'élément est actuellement utilisé */
  public isUsed(): boolean {
    // console.log('owner', this.owner);
    return this.owner.id === 'freeList' && this.data.isUsed; // affichage de l'oeil uniquement dans la liste de choix
  }

  /** champ I éditable */
  public isEditable(): boolean {
    return this.data.editable && !this.data.isFilterKey;
  }

  /** champ I éditable */
  public isFormula(): boolean {
    return this.data.isFormula;
  }

  
  /** champ key */
  public isKey(): boolean {
    return this.data.isKey && !this.data.isFilterKey;
  }

  /** champ filters */
  public isFilterKey(): boolean {
    return this.data.isFilterKey;
  }

  /** icone de suppression du champ de la zone de contenu, affichage uniquement dans les zones de drop */
  public isInContentList(): boolean {
    // console.log('owner', this.owner);
    return this.owner.id !== 'freeList';
  }

  /** suppression d'un élément des zones de contenu */
  public doDelete(): void {
    this.owner.wizDataProvider.removeItem(this.data);
    WizEventManager.dispatchEvent(this.owner.elementRef, new WizEvent(WIZ_EVENT_TYPE.DELETE, null, this.data));
  }

  /** ouverture de la sub-pop pour configurer la formule (et à terme, le style) */
  public showConf(): void {
    WizEventManager.dispatchEvent(
      this.owner.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD, [this.data, this.owner])
    );
  }

  /** champ en ligne locked */
  public isPinned(): boolean {
    // console.log('isPin', this.data.pinned, this.data.fkd.pinned);
    return !!this.data.pinned;
    // return !!this.data.fkd.pinned;
  }
  public setPinned(e: WizEvent) {
    this.data.pinned = e.value ? 'left' : null;
  }

  /** champ en ligne locked */
  public showPinned(): boolean {
    return (
      (this.owner.id === 'lstRow' || this.owner.id === 'lstData') &&
      (this.data.popUpMode === WIDGET_KIND.GRID || this.data.popUpMode === WIDGET_KIND.PIVOT)
    );
  }
}
